/*
  Note:
  Instead of Duplication Common Configurations in all the environments,
  All Common Configurations can be placed here and can be used in all the environments.
 */

export const EnvironmentConfig = {
  portalRoute: {
    normal: 'home',
    broker: '/broker/dashboard',
    provider: '/provider/dashboard'
  },
  allowBrokerPortalAccess: false,
  claimManagementFeatures: {
    cases: false,
    payments: false,
    inbox: false
  },
  externalClientUrl: {
    Bonitas: 'https://www.bonitas.co.za/broker',
    Empty: ''
  },
  jiraWidgetKeys: {
    iPBM: '23f38245-dda9-4e9d-8e05-a30855e9ec81',
    Greydom: '6201c3c8-5ef3-46d0-8555-aeba3710b263',
    Bonitas: '2f41fccf-f866-4b72-93ad-bcfc48a894b4',
    NoKey: ''
  },
  themes: {
    Greydom: 'greydom',
    iPBM: 'ipbm',
    GEMS: 'gems',
    Bonitas: 'bonitas',
  },
  favicon: {
    Greydom: 'favicon-gre.ico',
    GEMS: 'favicon-gems.ico',
    Bonitas: 'favicon-bon.ico',
    iPBM: 'favicon-ipbm.ico',
  },
  vatPercentage: 15,
  acceptedApplicationLookBackDays: 30,
  applicationCapture: {
    scheme: {
      schemeCode: 'DEV',
      schemeName: 'DEVELOP'
    },
    individualCode: 'BON996DPP',
    allowCommunicationPackSend: false
  },
  schema:{
    diagnosisType: 'SA ICD-10 MIT'
  }
};
